import { render } from "./MyWork.vue?vue&type=template&id=c170bac6&scoped=true"
import script from "./MyWork.vue?vue&type=script&lang=js"
export * from "./MyWork.vue?vue&type=script&lang=js"

import "./MyWork.vue?vue&type=style&index=0&id=c170bac6&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c170bac6"]])

export default __exports__